<template>
    <div class="card card-body d-flex flex-column gap-1 text-center p-4 border" :class="cardClasses">
        <h2 class="m-0">{{ integration.name }}</h2>
        <div class="text-muted">{{ integration.description || __('general.description_not_available') }}</div>
        <div>
            <div v-if="integration.state === 'enabled'"
                 class="badge bg-light-success text-success">
                <i class="fas fa-check"/>
                {{ __('integrations.active') }}
            </div>
            <div v-if="integration.state === 'missing_config'">
                <div class="badge bg-light-warning text-warning">
                    <i class="fas fa-exclamation-triangle"/>
                    {{ __('integrations.missing_config') }}
                </div>
                <div class="font-size-lg text-warning">
                    {{ __('integrations.please_provide_required_configs') }}
                </div>
            </div>
            <div v-if="integration.state === 'disabled'"
                 class="badge bg-light-danger text-danger">
                <i class="fas fa-ban"/>
                {{ __('general.thing.disabled', {thing: __('general.integration')}) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        integration: Object
    },

    computed: {
        cardClasses() {
            if (this.integration.state === 'enabled') {
                return 'bg-light-success border-success'
            } else if (this.integration.state === 'missing_config') {
                return 'bg-light-warning border-warning';
            } else if (this.integration.state === 'disabled') {
                return 'bg-light-danger border-danger';
            }
        }
    }
}
</script>
